import { Type } from "@sinclair/typebox";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../lib/api.js";
import { surveyDataSchema } from "../types/survey.js";
import { getClientQueryOptions } from "./getClient.js";
export const surveyDataResponseSchema = Type.Object({
    success: Type.Boolean(),
});
export const updateSurveyDataBodySchema = Type.Partial(surveyDataSchema);
export const updateSurveyData = ({ userId, data, }) => {
    return api
        .patch(`clients/${userId}/persistSurveyData`, {
        json: data,
    })
        .json();
};
export const useUpdateSurveyData = ({ mutationConfig, } = {}) => {
    const queryClient = useQueryClient();
    const { onSuccess, onMutate, ...restConfig } = mutationConfig || {};
    return useMutation({
        onMutate: (surveyData) => {
            queryClient.setQueryData(getClientQueryOptions(surveyData.userId).queryKey, (oldClient) => {
                if (!oldClient) {
                    return undefined;
                }
                return {
                    ...oldClient,
                    onboarding_tags: {
                        ...oldClient.onboarding_tags,
                        ...(surveyData.data.tagsGoals !== undefined && {
                            goals: surveyData.data.tagsGoals,
                        }),
                    },
                    ...(surveyData.data.weightSystem !== undefined && {
                        preferred_weight_system: surveyData.data.weightSystem,
                    }),
                };
            });
            onMutate?.(surveyData);
        },
        onSuccess: (data, ...args) => {
            void queryClient.invalidateQueries({
                queryKey: ["clients"],
            });
            onSuccess?.(data, ...args);
        },
        ...restConfig,
        mutationFn: updateSurveyData,
    });
};
//# sourceMappingURL=updateSurveyData.js.map